import * as React from 'react';
import { NavLink } from 'react-router-dom';
//import * as CheckAuth from './Shared';
import { toast } from 'react-toastify';
import { GetQuery } from './Shared';

const NavMenu = () => {
    const [loading, setLoading] = React.useState(true);
    const [permissions, setPermissions] = React.useState<string[]>([]);
    const [companyId, setCompanyId] = React.useState(3);
    const [noItemTasks, setNoItemTasks] = React.useState(0);
    const [noCredits, setNoCredits] = React.useState(0);
    const [noRunsheetDriverJobs, setNoRunsheetDriverJobs] = React.useState(0);

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        //var isAuth = await CheckAuth.checkAuth();

        //if (isAuth) {
            const apiUrl = "GetNavMenu";
            var result = await GetQuery(apiUrl);

            if (result.error) {
                toast.error("Error getting data!");
            } else {
                setPermissions(result.data.userPermissions);
                setCompanyId(result.data.companyId);
                setNoRunsheetDriverJobs(result.data.numberOfRunsheetDriverJobs);
                setNoItemTasks(result.data.numberOfItemTasks);
                setNoCredits(result.data.numberOfCreditTasks);
                setLoading(false);
            }
        //} else {
        //    //redirect to login screen
        //    window.location.replace("/bff/login");
        //}
    }

    const renderDetails = (
        <div>
            <div className="navbar-container">
                <ul className="nav-menu">
                    <li className="nav-item">
                        <NavLink to="/" className="nav-link">
                            Home
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/jobsearch" className="nav-link">
                            Job Search
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("CreateJob") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link" to={'/newjob/' + (companyId === 3 ? 2 : 1)}>
                            New Job
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("CreateJob") < 0 || companyId != 3 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/newjob/3'} >
                            New Quote
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewItemTasks") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/itemtasks'}>
                            Item Tasks({noItemTasks})
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("CreateEditSchedule") < 0 || companyId != 2 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/schedulenew'}>
                            Schedule
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewTiltCraneSchedule") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/scheduletiltcrane'}>
                            Tilt/Crane Schedule
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewEventSchedule") < 0 || companyId != 3 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/scheduleevent'}>
                            Event Schedule
                        </NavLink>
                    </li>
                    <li className={companyId != 2 ? "nav-item hideMobile" : "hidden"}>
                        <NavLink className="nav-link alignitemscentre" to={'/schedulepickup'}>
                            Schedule Pickup
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewAllocation") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/allocate'}>
                            Allocate
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewAllocationDatabase") < 0 ? "hidden" : "hidden"}>
                        <NavLink className="nav-link alignitemscentre" to={'/allocatedatabase'}>
                            Allocate New
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewRunSheetUpdates") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/runsheet'}>
                            Run Sheet
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewRunSheetUpdates") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/runsheetdriver'}>
                            Run Sheet Driver({noRunsheetDriverJobs})
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("RunReports") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/reports'}>
                            Reports
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("CreateEditCustomers") >= 0 || permissions.indexOf("ViewCustomers") >= 0 || permissions.indexOf("CreateQuoteOnlyCustomer") >= 0 ? "nav-item hideMobile" : "hidden"}>
                        <NavLink className="nav-link alignitemscentre" to={'/customersearch'}>
                            Customers
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("UpdateJobToPaid") < 0 || companyId === 2 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/jobsrequiringpayment'}>
                            Update jobs to Paid
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("SendInvoices") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/sendinvoices'}>
                            Send Invoices
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewInvoices") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/invoices'}>
                            Invoices
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewSendInvoiceBatch") < 0 && permissions.indexOf("SendInvoiceBatchEventInvoices") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/invoicebatch'}>
                            Invoice Batch
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("ViewSendInvoiceCredits") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/invoicecredit'}>
                            Invoice Credits({noCredits})
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("CreateEditUsers") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/usersearch'}>
                            Users
                        </NavLink>
                    </li>
                    <li className={permissions.indexOf("CreateEditAdminLists") < 0 ? "hidden" : "nav-item hideMobile"}>
                        <NavLink className="nav-link alignitemscentre" to={'/adminlists'}>
                            Admin Lists
                        </NavLink>
                    </li>
                </ul>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );

}

export default NavMenu;